export default __webpack_public_path__ + "static/media/elabogado.39268307.webp";